import React from 'react';
 import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import 'semantic-ui-css/semantic.min.css';
import MenuItem from '@material-ui/core/MenuItem';
import axios from 'config/axios';
import env from 'config/env';
import Swal from 'sweetalert2';
import { UpdatepasswordInput } from 'lib/helpers';


const swalWithBootstrapButtons1 = Swal.mixin({
  customClass: {
    cancelButton: 'btn btn-default',
    confirmButton: 'btn btn-danger',
  },
  buttonsStyling: false,
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      display: 'block',
      marginTop: theme.spacing(2),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    conf: {
      border: '0',
      borderRadius: '.25em',
      background: 'initial',
      backgroundColor: '#e64942',
      color: '#fff',
      fontSize: '1.0625em',
      margin: '.3125em',
      padding: '.625em 1.1em',
      boxShadow: 'none',
    },
    yesConfirm: {
      backgroundColor: '#e3342f !important',
      fontSize: '13px !important',
      fontWeight: 400,
      paddingTop: '12px',
      paddingLeft: '11px',
      paddingRight: '11px',
      paddingBottom: '9px',
      borderColor: '#e3342f !important',
    },
    noCancel: {
      backgroundColor: '#888',
      fontSize: '13px !important',
      fontWeight: 400,
      paddingTop: '12px',
      paddingLeft: '11px',
      paddingRight: '11px',
      paddingBottom: '9px',
    },
  }),
);

interface DropDownI {
  setLoad: (e: boolean) => void;
  depData: any[];
  row: any;
  status: string;
  deleteData: any;
  setClickData: (e: any) => void;
  setEditOpen: (e: boolean) => void;
}

const DropDown: React.FC<DropDownI> = ({
  depData,
  row,
  setLoad,
  setClickData,
  setEditOpen,
}) => {
   const classes = useStyles();
  const [load, setReload] = React.useState<boolean>(true);

  // const disDelete = row => {
  //   var myhtml = document.createElement('div');
  //   myhtml.setAttribute('id', 'Div1');
  //   myhtml.innerHTML =
  //     "<div class='row text-center' style='width:inherit;align-content: center;'><h2 class='swal-text text-center' style='margin-left: 5%;margin-top: 0px;font-size: 23px;'><b>You Are About To Delete Selected Notification Type?</b></h2> <br/><div class='swal-text' style='margin-left: 29%;padding-bottom: 10px;font-size: 18px;margin-top: 10px;'>Click Yes To Delete</div><br/><div  style='width:88%;'><input type='password' id='password' class='form-short' style='width:96%!important;height: 37px;margin-left: 15px;' placeholder='Password' autocomplete='off'/></div><div  style='margin-left: 0px;'><button  class='input-group-text' style='width:41px;height: 37px;' onclick='bsd()' ><div onclick='asd()'><i class='zmdi zmdi-eye' id='zmdi' onclick='asd()' ></i></div></div></button></div></div>";
  //   var g = document.createElement('script');
  //   var s = document.getElementsByTagName('script')[0];
  //   g.text =
  //     'function asd(){var y=document.getElementById("zmdi");var x=document.getElementById("password"); if(x.type=="password"){x.type="text";y.className="zmdi zmdi-close";y.style="margin-left:2px;"}else{x.type="password";y.className="zmdi zmdi-eye";y.style="margin-left:0px"}};function bsd(){var y=document.getElementById("zmdi");var x=document.getElementById("password"); if(x.type=="password"){x.type="text";y.className="zmdi zmdi-close";y.style="margin-left:2px;"}else{x.type="password";y.className="zmdi zmdi-eye";y.style="margin-left:0px"}};';

  //   s.parentNode.insertBefore(g, s);

  //   Swal.fire({
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes,Delete!',
  //     cancelButtonText: 'No,Cancel!',
  //     reverseButtons: true,
  //     customClass: {
  //       confirmButton: classes.yesConfirm,
  //       cancelButton: classes.noCancel,
  //     },
  //     html: myhtml,
  //   }).then(result => {
  //     if (result.isConfirmed) {
  //       // @ts-ignore
  //       let inputval = document.getElementById('password').value;
  //       var url = window.location.hostname;
  //       if (inputval !== '') {
  //         axios
  //           .post(`https://${url}/pass-check`, {
  //             pass: inputval,
  //           })
  //           .then(res => {
  //             let resp: any = res;
  //             if (resp.success) {
  //               deleteDa(row);
  //             } else {
  //               Swal.fire({
  //                 icon: 'error',
  //                 title: resp.message,
  //                 text: 'Please check your password',
  //                 customClass: {
  //                   confirmButton: classes.conf,
  //                 },
  //               });
  //             }
  //           })
  //           .catch(res => {
  //             Swal.fire({
  //               icon: 'error',
  //               title: 'Failed',
  //               text: 'Please check your password',
  //               buttonsStyling: false,
  //               customClass: {
  //                 confirmButton: classes.conf,
  //               },
  //             });
  //           });
  //       } else {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Failed',
  //           text: 'Please check your password',
  //           buttonsStyling: false,
  //           customClass: {
  //             confirmButton: classes.conf,
  //           },
  //         });
  //       }
  //     }
  //   });
  // };

  // const deleteDa = async dltOb => {
  //   axios.defaults.withCredentials = true;
  //   const deleteArray = {
  //     uuids: [row.uuid],
  //   };
  //   await axios({
  //     method: 'delete',
  //     url: `${env.apiURL}/invoice/`,
  //     //   headers: {
  //     //     Authorization: "Bearer  132|IR81koFx0wOL78KLbejQ7dog9UWkjoNJ8LG40KHd",
  //     //     'Access-Control-Allow-Origin': true,
  //     //   },
  //     data: deleteArray,
  //   })
  //     .then(error => {
  //       Swal.fire({
  //         position: 'center',
  //         icon: 'success',
  //         title: 'Success',
  //         text: 'Deleted!Successfully ',
  //         confirmButtonColor: '#2778c4',
  //         showConfirmButton: true,
  //       }).then(function() {
  //         setReload(false);
  //       });
  //     })
  //     .catch(error => {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Sorry..!',
  //         text: error.message,
  //       });
  //     });
  // };
  React.useEffect(() => {
    if (!load) {
      setLoad(load);
    }
    setReload(true);
  }, [load, setLoad]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const alert = (rno) => {
   
        swalWithBootstrapButtons1
       .fire({
         icon: 'warning',
         title: 'Warning',
         
         showCancelButton: true,
         confirmButtonText: 'Yes,Confirm!',
 
         cancelButtonText: 'No, Cancel!',
         reverseButtons: true,
         allowOutsideClick: false,
         html:"<h4>You Are About to Delete an Invoice ,This Process is irreversible "+'\n'.replace(/\n/g, '<br>')+" Click Yes to Confirm </h4>"+UpdatepasswordInput(),
       })
       .then(result => {
         if (result.isConfirmed) {
           // @ts-ignore
           let inputval = document.getElementById('password').value;
           var url = window.location.hostname;
           if (inputval !== '') {
             axios
               .post(`https://${url}/pass-check`, {
                 pass: inputval,
               })
               .then(res => {
                 let resp: any = res;
                 if (resp.success) {
                  deleteInvoice(rno);
                  
                  
                 } else {
           
                   Swal.fire({
                     icon: 'error',
                     title: 'Failed',
                     text: 'Please check your password',
                     customClass: {
                       confirmButton: classes.conf,
                     },
                   });
                 }
               });
         
           } else {
           
             Swal.fire({
               icon: 'error',
               title: 'Failed',
               text: 'Please check your password',
               buttonsStyling: false,
               customClass: {
                 confirmButton: classes.conf,
               },
             });
            
           }
         }
         else{ return}
       }
       
       );
    
   };
 

    const deleteInvoice= async rno => {

    axios.defaults.withCredentials = true;
    await axios({
      method: 'delete',
      url: `${env.apiURL}/invoice/delete_invoice/${rno}`,
 
    })
      .then(error => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Success',
          text: 'Deleted!Successfully ',
          confirmButtonColor: '#2778c4',
          showConfirmButton: true,
        });
        setLoad(false);
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Sorry..!',
          text: error.message,
        });
      });
  };

  return (
    <div className="dropdown">
      {/* <button
        onClick={() => {
          setClickData(row);
          setEditOpen(true);
        }}
        className="eye-icon "> */}
      {/* <i className="fas fa-eye">hi</i> */}
      <i
        className="zmdi zmdi-more zmdi-hc-border-circle"
        style={{ cursor: 'pointer' }}
        onClick={handleMenu}>
        {' '}
      </i>
      {/* </button> */}
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onBackdropClick={handleClose}
        onScroll={handleClose}
        onBlur={handleClose}
        MenuListProps={{ onMouseLeave: handleClose }}
        autoFocus
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{
          willChange: 'scroll-position',
          position: 'absolute',
        }}>
        <MenuItem
          onClick={() => {
            setClickData(row);
            setEditOpen(true);
          }}>
          <a
            href="# "
            onClick={() => {
              setClickData(row);
              setEditOpen(true);
            }}>
            Edit
          </a>
        </MenuItem>
        <MenuItem onClick={() => console.log(row)}>
          <a href="# " onClick={() => alert(row.invoiceId)}>
            Delete
          </a>
        </MenuItem>
      </Menu>
    </div>
  );
};
export default React.memo(DropDown);
